import React, { Component } from "react";
import { Icon, Button,Label,Segment, ButtonGroup,Modal  } from 'semantic-ui-react';
import { Link, withRouter } from 'react-router-dom';
import headerLogo from './../../assets/new-logo.svg';
import mobileLogo from './../../assets/SEF-Logo-Master-CMYK.png';
import {AuthService} from "../../services/auth-service";
import './header.scss';
import { withMsal} from "@azure/msal-react";
import { BreadcrumbContext } from './breadcrumbcontext';
import CustomLink from '.././formatters/customlink'; // Adjust the import path as necessary
import { Sticky } from 'react-sticky';

class header extends Component {
    static contextType = BreadcrumbContext;
   
    constructor(props)
    {
        super(props);
        this.authServices = new AuthService();

        this.state = {
            isAdmin: false, // Default to false until the check is complete
            isMultiClient : this.authServices.isMultiClient(),
            customerId : this.authServices.getUserData(AuthService.CUSTOMER_ID_KEY),
            hasProcurement : this.authServices.hasRole("Procurement"),
            hasSiera : this.authServices.hasRole("Siera"),
            hasDataMapsAdmin : this.authServices.hasRole("DataMaps Admin"),
            isReadOnly : this.authServices.isReadOnly(),
            cotQueue : this.authServices.getCotQueue(),
            refreshState : false,
            showInactivityModal: false

        }

       
    }

    componentDidMount() {
        // Start the inactivity timer
        this.authServices.startInactivityTimer();
        this.inactivitySubscription = this.authServices.inactivitySubject.subscribe((showModal) => {
            this.setState({ showInactivityModal: showModal });
        });
    
        // Check if the user is an admin
        this.checkAdminStatus();
    }
    
    checkAdminStatus = async () => {
        const isAdmin = await this.authServices.isUserAdmin();
        this.setState({ isAdmin });
    };
    
    
      componentWillUnmount() {
        if (this.inactivitySubscription) {
          this.inactivitySubscription.unsubscribe();
        }
      }
    
      handleStayActive = () => {
        this.setState({ showInactivityModal: false });
        this.authServices.resetInactivityTimer();
      }

    
    logoutUser = () => {
       

        this.authServices.clearUserCache();
      
        const isAuthenticated = this.props.msalContext.accounts.length > 0;
        const msalInstance = this.props.msalContext.instance;

        // If a user is not logged in and authentication is not already in progress, invoke login
        if (isAuthenticated) {
            msalInstance.logout()
            this.props.history.push("/logout");
            window.location.reload();
        }else
        {
            this.props.history.push("/logout");
            window.location.reload();

        }
        
     
    };
   
    translateSiteChangeStatus = (status) => 
    {
if(status === "removeMeter")
{
    return "Remove Meter"
}else if(status === "moveOut")
{
    return "Move Out"
}else if(status === "newMeter")
{
    return "New Meter"
}else  if(status === "other")
{
    return "Other"
}else 
{
    return status
}
        
    }

    handleRestartNewSite = (name, value) => {
       
        this.props.history.push("/sites?queue="+value.id);
        window.location.reload();
    
    };

    handleRestartSiteUpdate = (name, value) => {
      
     this.props.history.push("/site?siteKey=" + value.value + "&queue="+ value.id);
            window.location.reload();
    };

    handleRemoveQueueItem = (name, value) => {
       
       this.authServices.removeCotQueueItem(value.id,value.value).then( () =>
       {
        this.setState({
            cotQueue: this.authServices.getCotQueue(),
            refreshState:!this.state.refreshState})  

        //window.location.reload();
       })
       

    };

    render() {
        const { breadcrumbs } = this.context;

        return (
           
            <div id="global-nav">
                <div id="desktop-nav">
                    <Link to="/">
                        <img src={headerLogo} alt="header-logo" id="desktop-logo" />
                    </Link>
                    
                    <Modal open={this.state.showInactivityModal} size="tiny">
          <Modal.Header>Are you still there?</Modal.Header>
          <Modal.Content>
            <p>Your session will expire in 10 minutes due to inactivity. Do you want to stay logged in?</p>
          </Modal.Content>
          <Modal.Actions>
            <Button negative onClick={this.authServices.logoutUser}>
              Logout
            </Button>
            <Button positive onClick={this.handleStayActive}>
              Stay Logged In
            </Button>
          </Modal.Actions>
        </Modal>

                    <div className="navbar">
                    {false && 
                        <div className="dropdown">
                        <Button className="menuIconbutton" icon > 
                        <Icon name='alarm' />
                            </Button>
                            <div className="cot-user-content">
                            <React.Fragment>
                                <h3>Resumable Site Requests</h3>
                            <div className="repeater-body">
                                        {this.state.cotQueue.map(x =>
                                             <Segment  key={x.id}>
                                                
<Label>
                                                        {this.translateSiteChangeStatus(x.changeReqested) + " - " +  ((x.siteAddress !== undefined &&  x.siteAddress.length >= 30) ? x.siteAddress.substring(0, 30) + '...' : x.siteAddress )}   
                                                        <br></br> {"Expected Change Date :" + x.changeDate }  
                                                        </Label>
                                                      
                                                        <ButtonGroup floated="right" >
                                                            <Button
                                                                negative
                                                                id={x.id}
                                                                value={x.siteId}
                                                                onClick={this.handleRemoveQueueItem}
                                                            >                        <Icon name='trash' />
                                                            </Button>
                                                            {x.siteId === 'New' ? 
                                                                <Button 
                                                                positive  
                                                                id={x.id}
                                                                value={x.siteId}
                                                                onClick={this.handleRestartNewSite}>Resume</Button>
                                                                : <Button positive
                                                                id={x.id}
                                                                value={x.siteId}
                                                                onClick={this.handleRestartSiteUpdate}>Resume</Button>
                                                                
                                                        }   
                                                       </ButtonGroup>    
                                                    
                                                 
                                                </Segment>

                                        )}
                                    </div>

                                </React.Fragment>
                            </div>
                        </div>
                        }
                        <div className="dropdown">
                            
                            <button className="dropbtn">Account Management
                            {/* <i className="fa fa-caret-down"></i> */}
                            </button>
                            <div className="dropdown-content">
                                <Link to={{pathname: "/sites",
                            state: {clearStore:true}
                            }}  >Sites</Link>
                                <Link to={{pathname: "/meters",
                            state: {clearStore:true}
                            }} >Meters</Link>
                                <Link to="/hh">Half-Hour Data</Link>
                                <Link to="/supplier-invoices">Supplier Invoices</Link>
                                <Link to={{
                                    pathname: "/documents",
                                    state: { isUserGuideMode: false }
                                }} >Documents</Link>
                               
                        {(this.authServices.hasHHCentActive(this.state.customerId)) &&
                        <Link to="/hhdatacentre">Half Hour Data Centre</Link>
                        
                        }
                          {(this.authServices.getCotsStatus() !== 'none') &&

                                         <Link to="/cotqueue">Saved site/meter change requests</Link>

    } 
                            </div>
                        </div>
                        {this.state.hasProcurement &&
                        <Link to="/procurement">Procurement</Link>
                        }

                            
                        <Link to="/reports" >Reports</Link>
                       

                        <Link className="" to={{
                                    pathname: "/service-management",
                                    state: { isUserGuideMode: false, cardClicked: "Open"  },
                                    
                                        }} >
                                Case Management
                            </Link>
                         
                        <div className="dropdown">
                            <button className="dropbtn">User Guide
                                {/* <i className="fa fa-lg fa-user"></i> */}
                            </button>
                            <div className="user-content">
                                                                <Link 
                                className="" 
                                to={{
                                    pathname: "/userguides",
                                    state: { isUserGuideMode: true }
                                }} 
                                onClick={this.closeNav}>
                                User Guides
                                </Link>
                                <Link 
                                className="" 
                                to={{
                                    pathname: "/userpolicy",
                                    state: { isUserPolicyMode: true }
                                }} 
                                onClick={this.closeNav}>
                                User Policy
                                </Link>
                                <Link 
                                className="" 
                                to={{
                                    pathname: "/videoguides"
                                    
                                }} 
                                onClick={this.closeNav}>
                                Video Guides
                                </Link>
                                <Link to="/about">About</Link>
                            </div>
                        </div>
                        <div className="dropdown">
                            <button className="dropbtn">User Settings
                                {/* <i className="fa fa-lg fa-user"></i> */}
                            </button>
                            <div className="user-content">
                                
                                {this.state.isAdmin &&
                                <React.Fragment>
                                    <Link to="/loginDomain">Switch Client</Link>
                                    <Link to="/user-management">User Management</Link>
                                    <Link to="/datamaps">Data Mapper</Link>

                                    
                                    {this.state.hasDataMapsAdmin &&
                                    <Link to="/datamapsadmin">Data Mapper Admin</Link>
                                     }
                                    {/* <Label basic>
                                        {this.authServices.getUserData(AuthService.CUSTOMER_NAME_KEY)}
                                    </Label> */}
                                                                      <Link to="/cotsclientmanager">Cots Client Manager</Link>

                                </React.Fragment>
                                
                                }
                                 {(this.state.isMultiClient && !this.state.isAdmin) &&
                                <React.Fragment>
                                    <Link to="/switchUserClient">Switch Client</Link>
                                    {/* <Label basic>
                                        {this.authServices.getUserData(AuthService.CUSTOMER_NAME_KEY)}
                                    </Label> */}
                                </React.Fragment>
                                
                                }
                                <a onClick={this.logoutUser}>Log Out</a>
                               
                              
                            </div>
                        </div>

              
                          
                    </div>
 
                </div>

                <div id="mobile-nav">
                    <Link to="/">
                        <img src={mobileLogo} alt="mobile-logo" id="mobile-logo"/>
                    </Link>
                                <span 
                                onClick={this.openNav} 
                                id="open-nav" 
                                className="nav-button"
                                dangerouslySetInnerHTML={{ __html: "&#9776;" }}
                            />

                    <div id="side-nav">

                        <div id="side-nav-container">
                            
                                <span 
                                onClick={this.closeNav} 
                                id="close-nav" 
                                className="nav-button"
                                dangerouslySetInnerHTML={{ __html: "&times;" }}
                            />
                            <br/>
                            <span className="nav-item" onClick={() => this.showSection("account-mgmt")} >
                                Account Management 
                                <span>&#9660;</span>
                            </span>
                            <div id="account-mgmt" className="hidden-content">
                                <Link className="" to="/sites" onClick={this.closeNav}>Sites</Link>
                                <Link className="" to="/meters" onClick={this.closeNav}>Meters</Link>
                                {/* <Link className="" to="/waste" onClick={this.closeNav}>Waste</Link> */}
                                <Link className="" to="/hh" onClick={this.closeNav}>Half-Hour Data</Link>
                                <Link className="" to="/supplier-invoices" onClick={this.closeNav}>Supplier Invoices</Link>
                                <Link className="" to={{
                                    pathname: "/documents",
                                    state: { isUserGuideMode: false }
                                }} onClick={this.closeNav}>Documents</Link>
                            </div>

                            {/* <span className="nav-item"  id="" onClick={() => this.showSection("procurement")} >
                                Procurement 
                                <span>&#9660;</span>
                            </span>
                            <div id="procurement" className="hidden-content">
                                <Link to="/contracts" onClick={this.closeNav}>Contracts</Link>
                                <Link to="/budgets" onClick={this.closeNav}>Budgets</Link>
                                <Link to="/triggers" onClick={this.closeNav}>Triggers</Link>
                                <Link to="/closing-prices" onClick={this.closeNav}>Closing Prices</Link>
                            </div> */}
                            
                            <Link to="/reports" onClick={this.closeNav}>
                                <span className="nav-item">Reports</span>
                            </Link>



                                
                            <Link className="" to={{
                                    pathname: "/service-management",
                                    state: { isUserGuideMode: false,  linkState:{ cardClicked: "Open" } },
                                    
                                        }} onClick={this.closeNav}>
                                <span className="nav-item">Service Management</span>
                            </Link>

                            <span className="nav-item"  id="" onClick={() => this.showSection("user-settings")} >
                                User Settings 
                                <span>&#9660;</span>
                            </span>
                            <div id="user-settings" className="hidden-content">
                                <Link to="/switch-profile" onClick={this.closeNav}>Switch Profile</Link>
                                <Link to="/user-management" onClick={this.closeNav}>User Management</Link>
                                <Link to="/logout" onClick={this.closeNav}>Log Out</Link>
                            </div>

                            

                        </div>
                        
                    </div>
                </div>
                
                <Sticky topOffset={80}>
                    {({ style }) => (
                        <nav style={{ ...style, zIndex: 4 }}>
                            <div className="ui segment breadcrumb-segment">
                                <span className="ui breadcrumb">
                                    <CustomLink to="/">
                                        <Icon name="home" color="grey" style={{ marginRight: '5px' }} />
                                    </CustomLink>
                                    {breadcrumbs.length > 0 && <i className="right angle icon divider"></i>}
                                </span>
                                {breadcrumbs.map((breadcrumb, index) => (
                                    <span key={index} className="ui breadcrumb">
                                        <CustomLink to={breadcrumb.path}>{breadcrumb.title}</CustomLink>
                                        {index < breadcrumbs.length - 1 && <i className="right angle icon divider"></i>}
                                    </span>
                                ))}
                            </div>
                        </nav>
                    )}
                </Sticky>

            </div> 
           
        );
    }

    openNav() {
        document.getElementById("side-nav").style.width = "80%";
    }

    closeNav() {
        document.getElementById("side-nav").style.width = "0";
    }

    showSection(elementName) {
        var element = document.getElementById(elementName);
        if (element.style.display === "none") {
            element.style.display = "block";
        } else {
            element.style.display = "none";
        }
    }
}

export default withMsal(withRouter(header)); 